import styled from 'styled-components';

export const UiRecordPage = styled.div`
	display: block;
`;